import { resolveUrl } from "./xhr";
import { GetSizeWithAspectRatio, GetAspectRatio } from "./aspect";
import LStorage from "./storage";

import { Base64 } from 'js-base64';
import Keyboard from "simple-keyboard";

declare const SDK: any;
declare const native: any;

const maxResolution = 1280;
const gameAspect = 600 / (400 + 40);
// const gameAspect = 1280 / (768 + 40);
const Module: any = {};

Module.ls = new LStorage(SDK !== undefined && SDK.localStorage !== undefined ? SDK.localStorage : window.localStorage, "space-cadet-pinbal.");
Module.encode = Base64.fromUint8Array;
Module.decode = Base64.toUint8Array;

window.addEventListener("resize", resizeCanvas, { capture: true });
const addEventListenerFn = window.addEventListener;
window.addEventListener = function (...args: any[]) {
    if (args[0] !== "resize") {
        addEventListenerFn.apply(window, args as any);
    } else {
        // do nothing
    }
}

window.addEventListener("contextmenu", (e) => e.preventDefault());

window.addEventListener("keydown", (e) => {
    if (e.code === "F5" || e.code === "KeyR") {
        e.preventDefault = () => {
            console.log("ignore prevent default");
        };
    }
}, { capture: true });

async function prepareRun() {
    function onProgess(percent: number) {
        const loaderText = document.getElementById("loader-text") as HTMLDivElement;
        loaderText.innerHTML = Math.round(percent) + "%";
        if (SDK?.loading) {
            SDK.loading(Math.round(percent));
        }
    }

    const lang = SDK?.lang !== undefined && SDK.lang() === "ru" ? "ru" : native.lang();

    const [data, wasm, wasmJs, dataJs] = await Promise.all([
        resolveUrl("bin.data." + lang + "._.js", onProgess),
        resolveUrl("wbin.wasm"),
        resolveUrl("wbin.js"),
        resolveUrl("bin.data." + lang + ".js")]);


    const decoder = new TextDecoder();
    const wasmScript = decoder.decode(wasmJs);
    const dataScript = decoder.decode(dataJs);

    Module.canvas = document.getElementById("canvas");
    Module.getPreloadedPackage = (name: any, size: any) => data.buffer;
    Module.instantiateWasm = async (info: any, receiveInstance: any) => {
        const wasmModule = await WebAssembly.compile(wasm);
        const instance = await WebAssembly.instantiate(wasmModule, info);
        receiveInstance(instance, wasmModule);
    };
    Module.onRuntimeInitialized = () => setTimeout(doRun, 16);

    const moduleFn = new (Function as any)(["Module"], wasmScript);
    eval(dataScript);

    moduleFn(Module);

    prepareKeyboard();
}

function doRun() {
    Module.targetAspect = GetAspectRatio([gameAspect, gameAspect], "landscape", window);
    let [width, height] = GetSizeWithAspectRatio(innerWidth, innerHeight, Module.targetAspect);

    const aspect = width / height;

    if (width > maxResolution) {
        width = maxResolution;
        height = width / aspect;
    }

    (document.getElementById("loader-container") as HTMLDivElement).style.visibility = "hidden";
    const args = ["-r", width + "x" + height];

    if (SDK?.loaded) {
        const interstitialFn = SDK.interstitialAd;

        SDK.pause = Module._pause;
        SDK.resume = Module._resume;
		SDK.interstitialAd = function() {
		    SDK.pause();
		    interstitialFn().then(SDK.resume).catch(SDK.resume);
		};
        SDK.loaded().then(() => {
            Module.callMain(args);

            resizeCanvas();
            Module.canvas.style.visibility = "visible";
        });
    } else {
        Module.callMain(args);

        resizeCanvas();
        Module.canvas.style.visibility = "visible";
    }
}

function resizeCanvas(e?: Event) {
    const canvas = Module.canvas;
    if (canvas === undefined) {
        return;
    }

    const [width, height] = GetSizeWithAspectRatio(innerWidth, innerHeight, Module.targetAspect);

    canvas.style.position = "relative";
    canvas.style.top = (innerHeight / 2) + "px";
    canvas.style.left = (innerWidth / 2) + "px";
    canvas.style.marginTop = (-1) * (height / 2) + "px";
    canvas.style.marginLeft = (-1) * (width / 2) + "px";
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    window.scroll(0, 1);

    e?.stopPropagation();
}

prepareRun();

function prepareKeyboard() {
    const isTouch = !!('ontouchstart' in window);
    const isPointer = window.PointerEvent ? true : false;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    new Keyboard({
        layout,
        onKeyPress: (button: string) => {
            const keyCode = sdlMapping[button];
            if (keyCode === undefined) {
                return;
            }
            Module._Video_Key_Callback(keyCode);
            setTimeout(() => {
                Module._Video_Key_Callback(keyCode | 0x80);
            }, 16);

            if (button === "{enter}") {
                toggleKeyboard();
            }
        },
        preventMouseDownDefault: true,
        preventMouseUpDefault: true,
        stopMouseDownPropagation: true,
        stopMouseUpPropagation: true,
        autoUseTouchEvents: true,
        useMouseEvents: true,
    });


    const keyboardDiv = document.getElementById("keyboard") as HTMLDivElement;
    const keyboardContainer = document.getElementById("keyboard-container") as HTMLDivElement;

    keyboardDiv.style.visibility = "visible";

    if (isPointer) {
        keyboardDiv.addEventListener("pointerdown", toggleKeyboard);
    } else if (isTouch) {
        keyboardDiv.addEventListener("touchstart", toggleKeyboard);
    } else {
        keyboardDiv.addEventListener("mousedown", toggleKeyboard);
    }

    function toggleKeyboard(e?: Event) {
        if (keyboardContainer.style.visibility !== "visible") {
            keyboardContainer.style.visibility = "visible";
        } else {
            keyboardContainer.style.visibility = "hidden";
        }

        e?.stopPropagation();
        e?.preventDefault();
    };

    if (isMobile) {
        const native = (window as any).native;
        native.showKeyboard = () => keyboardContainer.style.visibility = "visible";
        native.hideKeyboard = () => keyboardContainer.style.visibility = "hidden";
    }
}

const layout = {
    default: [
        '1 2 3 4 5 6 7 8 9 0 {bksp}',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        'z x c v b n m {enter}',
    ],
};

const sdlMapping: { [index: string]: number } = {
    "1": 2,
    "2": 3,
    "3": 4,
    "4": 5,
    "5": 6,
    "6": 7,
    "7": 8,
    "8": 9,
    "9": 10,
    "0": 11,
    "q": 16,
    "w": 17,
    "e": 18,
    "r": 19,
    "t": 20,
    "y": 21,
    "u": 22,
    "i": 23,
    "o": 24,
    "p": 25,
    "a": 30,
    "s": 31,
    "d": 32,
    "f": 33,
    "g": 34,
    "h": 35,
    "j": 36,
    "k": 37,
    "l": 38,
    "z": 44,
    "x": 45,
    "c": 46,
    "v": 47,
    "b": 48,
    "n": 49,
    "m": 50,
    "{bksp}": 14,
    "{enter}": 28,
};
